<!-- =========================================================================================
  File Name: CustomerDebtListFormSidebar.vue
  Description: Add New Data - Sidebar component
========================================================================================== -->
<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			setDialogHide =>
				handleCloseDialog(() => {
					initValues();
					setDialogHide();
				}, isFormDirty)
		"
		class="custom-dialog todo-list-form-sidebar"
		:visible.sync="isSidebarActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">{{ $t("Division") }} {{ $t("Customer") }}</h4>
		</div>
		<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- ASSIGNEES -->
				<div class="">
					<!-- <label for class="vs-input--label"> {{ $t("Relations") }}<span class="text-danger">*</span>: </label> -->
					<cbs-relations-humanroles
						:data-vv-as="$t('Relations')"
						:placeholder="`${$t('Actions.Choose')} nhân viên/chức vụ/phòng ban`"
						name="assignees"
						v-model="objects"
						:type="1"
						:for="'people'"
						:modelType="$constant.RELATION_MODELS.TODO"
						v-validate="'required'"
					/>
					<span class="text-danger text-sm" v-show="errors.has('assignees')">{{ errors.first("assignees") }}</span>
				</div>
				<div v-html="$t('AllowedPeopleNote')" class="mb-5 mt-2"></div>

				<!-- Division -->
				<div>
					<label for class="vs-input--label">{{ $t("SetPermission") }}:</label>
					<vs-row class="flex w-full mb-2">
						<vs-col class="flex-1"></vs-col>
						<vs-col class="flex flex-1">
							<vs-checkbox v-model="checkViewAll"></vs-checkbox>
							<p class="text-base text-black">{{ $t("View") }}</p>
						</vs-col>
						<vs-col class="flex flex-1">
							<vs-checkbox v-model="checkUpdateAll"></vs-checkbox>
							<p class="text-base text-black">{{ $t("Update") }}</p>
						</vs-col>
					</vs-row>
					<vs-divider class="mt-0 pt-0" />
					<vs-row class="flex mb-4" v-for="(division, name) in dataDivision" :key="`division${name}`">
						<vs-col class="flex-1">
							<p class="text-base text-black">{{ division.display }}</p>
						</vs-col>
						<vs-col class="flex-1"> <vs-checkbox v-model="divisionCheck[division.name]['view']"></vs-checkbox> </vs-col>
						<vs-col class="flex-1">
							<vs-checkbox v-model="divisionCheck[division.name]['update']"></vs-checkbox>
						</vs-col>
					</vs-row>
					<!--  -->
				</div>
			</div>
		</perfect-scrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import CbsDepartments from "@/components/cbs-departments/CbsDepartments";
import customerGql from "@/http/requests/card/customer_gql";

export default {
	name: "CustomersDivisionDialog",
	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		vSelect,
		CbsDepartments
	},
	data() {
		return {
			isFormDirty: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			employeesChoices: [],
			refEmployee: "refEmployee",
			divisionCheck: {},
			checkViewAll: true,
			checkUpdateAll: true,
			objects: null
		};
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;

			this.initValues();
		},
		data: function(newVal, oldVal) {
			if (_.isEmpty(newVal) || newVal !== oldVal) {
				this.$nextTick(() => {
					if (this.$refs.vueScrollBar) {
						this.$refs.vueScrollBar.$el.scrollTop = 0;
					}
				});
			}
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData);
			},
			deep: true
		},

		checkViewAll(val) {
			_.mapKeys(this.divisionCheck, (value, key) => {
				this.divisionCheck[key]["view"] = val;
			});
		},
		checkUpdateAll(val) {
			_.mapKeys(this.divisionCheck, (value, key) => {
				this.divisionCheck[key]["update"] = val;
			});
		}
	},

	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar", false);
				}
			}
		},
		computedFormData() {
			return {
				objects: this.objects,
				divisionCheck: this.divisionCheck
			};
		},
		dataDivision() {
			return this.$store.state.customerManagement.acccessableFields;
		}
	},
	methods: {
		initValues() {
			this.objects = null;
			this.$store.state.customerManagement.acccessableFields.map(field => {
				this.divisionCheck[field.name] = {
					view: true,
					update: true
				};
			});
			this.isFormDirty = false;
			this.setInitFormData();
			this.$validator.reset();
		},
		setInitFormData() {
			this.$nextTick(() => {
				this.initFormData = {
					objects: this.objects,
					divisionCheck: this.divisionCheck
				};
			});
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: `${this.$t("SetPermission")} ${this.$t("Successful").toLowerCase()} `
				}
			});
		},
		async handleCreateOrUpdateCustomerDebt(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				try {
					await customerGql.customerMultipleUpdatePermissions(dataObj);
				} catch (error) {
					console.error("customerMultipleUpdatePermissions", error);
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					try {
						const content = this.divisionCheck;
						this.objects = this.objects.map(obj => ({ id: obj.id, type: obj.type }));
						const dataObj = {
							customer_ids: this.data.customer_ids,
							content: JSON.stringify(content),
							objects: this.objects
						};
						this.handleCreateOrUpdateCustomerDebt(dataObj, isCloseForm);
					} catch (error) {
						console.error(error);
					}
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped></style>
